<template>
  <v-container grid-list-xl fluid>
    <!-- TABLA DOCUMENTO -->
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-toolbar card color="white">
      <v-toolbar-title class="indigo--text"
        >Seleccione Reclutados</v-toolbar-title
      >
    </v-toolbar>
    <grid-capacitacion
      :key="gridDocumento"
      :rowsTable="rowsTable"
      :contratoId="contratoId"
    ></grid-capacitacion>
    <!-- TABLA DOCUMENTO -->
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridCapacitacion from "@/modules/aplicacion/views/seleccion/capacitacion/GridCapacitacion.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "capacitacion-seleccion-tab",

  components: {
    GridCapacitacion,
    Loading,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      loading: false,
      rowsTable: [20],
      idContrato: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      idUserLogged: "",
      proceso: "",
    };
  },

  mounted() {},
  created() {
    this.proceso = this.$store.getters.proSelectedStored;
  },

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
  },
};
</script>
